import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { KeycloakService } from '../services/keycloak/keycloak.service';
import { LocalStorageService } from '../services/localStorage/localStorage.service';

/**
 * Disconnects the user when a request returns a 401 error.
 * @param req
 * @param next
 * @returns
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const keycloakService = inject(KeycloakService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        keycloakService.logout(environment.logoutURL);
        localStorageService.clear();
      }
      return throwError(() => err);
    })
  );
};
